//AXIOS
import axios from 'axios';

//CREACIÓN DE INSTANCIA DE AXIOS 
const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API_URL,
    headers: {'X-Custom-Header': 'foobar'}
});

export default axiosClient;